import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { useSyncExternalStore, useCallback } from 'react';

interface BranchState {
  selectedBranchId: string | null;
  selectedBranchName: string | null;
  setSelectedBranch: (branchId: string | null, branchName: string | null) => void;
}

export const useBranchStore = create<BranchState>()(
  persist(
    (set) => ({
      selectedBranchId: null,
      selectedBranchName: null,

      setSelectedBranch: (branchId, branchName) =>
        set({ selectedBranchId: branchId, selectedBranchName: branchName }),
    }),
    {
      name: 'branch-storage',
      partialize: (state) => ({
        selectedBranchId: state.selectedBranchId,
        selectedBranchName: state.selectedBranchName,
      }),
    }
  )
);

// Hook to check if the branch store has been hydrated from localStorage
export const useBranchHydration = () => {
  const subscribe = useCallback((onStoreChange: () => void) => {
    const unsubscribe = useBranchStore.persist.onFinishHydration(onStoreChange);
    return unsubscribe;
  }, []);

  const getSnapshot = useCallback(() => {
    return useBranchStore.persist.hasHydrated();
  }, []);

  // For SSR, always return false
  const getServerSnapshot = useCallback(() => false, []);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
